import { qreqsNeedClear } from 'components/utils';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { begin } from 'actions/storylet';
import QualityRequirement from 'components/QualityRequirement';
import getBorderColour from 'utils/getBorderColour';
import StoryletComponent from './StoryletComponent';
import { IStorylet } from "types/storylet";

export interface Props {
  dispatch: Function,
  data: IStorylet,
}

function StoryletContainer(props: Props) {
  const { dispatch, data } = props;

  const ref = useRef<HTMLDivElement>(null);

  const [shouldClearQReqs, setShouldClearQReqs] = useState(false);
  const [isWorking, setIsWorking] = useState(false);

  const handleChoose = useCallback(() => {
    setIsWorking(true);
    dispatch(begin(data.id));
  }, [
    data.id,
    dispatch,
  ]);

  const borderColour = getBorderColour(data);

  const onResize = useCallback(() => {
    if (ref.current) {
      setShouldClearQReqs(qreqsNeedClear(ref.current));
    }
  }, []);

  const qualityRequirements = useMemo(() => {
    return [...data.qualityRequirements]
      .reverse()
      .map(quality => (
        <QualityRequirement
          key={quality.qualityId}
          data={quality}
          storylet
        />
      ));
  }, [data.qualityRequirements]);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    onResize();
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  return (
    <div ref={ref} data-branch-id={data.id}>
      <StoryletComponent
        borderColour={borderColour}
        data={data}
        forceClearQreqs={shouldClearQReqs}
        isWorking={isWorking}
        onCardClick={handleChoose}
        onChoose={handleChoose}
        qualityRequirements={qualityRequirements}
      />
    </div>
  );
}

StoryletContainer.displayName = 'StoryletContainer';

export default connect()(StoryletContainer);
